const blockHeroProduct = (Swiper, Navigation, Pagination, Autoplay, Thumbs) => {
	const swiperProduct1 = document.querySelector('.s-product-hero__swiper');
	const swiperProduct2 = document.querySelector('.s-product-hero__swiper2');
	if (swiperProduct1 && swiperProduct2) {
		const swiper = new Swiper('.s-product-hero__swiper', {
			loop: true,
			spaceBetween: 10,
			slidesPerView: 3,
			modules: [Navigation, Pagination, Autoplay, Thumbs],
			freeMode: true,
			watchSlidesProgress: true,
			pagination: false,
			breakpoints: {
				768: {
					slidesPerView: 4,
				},
			},
		});

		// eslint-disable-next-line no-unused-vars
		const swiper2 = new Swiper('.s-product-hero__swiper2', {
			loop: true,
			spaceBetween: 10,
			slidesPerView: 1,
			modules: [Navigation, Pagination, Autoplay, Thumbs],
			navigation: {
				nextEl: '.c-swiper-single-arrow--single-product.c-swiper-single-arrow--next',
				prevEl: '.c-swiper-single-arrow--single-product.c-swiper-single-arrow--prev',
			},
			slideToClickedSlide: true,
			pagination: false,
			thumbs: {
				swiper,
			},
		});
	}
};

export default blockHeroProduct;
